// filepath: d:\src\com.argodata.cdt.qd2.admin.muiconv\src\components\drawers\TagCreateEditDrawerHook.js
import React from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {closeDrawer} from "../../actions/drawerActions";
import {createTagAndCloseDrawer, saveTagAndCloseDrawer} from "../../actions/tagActions";
import {saveQuestionTemplate} from "../../actions/questionTemplateActions";
import TagEditorHook from "../qd/tags/TagEditorHook";
import ArgoAppBarHook from "../common/ArgoAppBarHook";
import * as portalShared from "../../portal/shared/metadataConstantsAndUtilities"

function TagCreateEditDrawerHook(props) {
    const {
        createMode,
        id,
        filter,
        closeDrawer,
        createTagAndCloseDrawer,
        saveTagAndCloseDrawer,
        saveQuestionTemplate,
        questionTemplates,
        setLoadingState
    } = props;

    const handleCloseDrawer = () => {
        closeDrawer();
    };

    const createTagAndClose = (tag) => {
        if (typeof setLoadingState === "function") {
            setLoadingState(function () {});
        }

        createTagAndCloseDrawer(tag, filter);
    };

    const saveTagAndClose = (tag, removedQuestions) => {
        if (typeof setLoadingState === "function") {
            setLoadingState(function () {});
        }

        // UPDATE QUESTIONS IF TAG REMOVED
        if (removedQuestions.length) {
            for (let i = 0; i < removedQuestions.length; i++) {
                let updatedTemplate = portalShared.cloneObj(questionTemplates[removedQuestions[i]]); // Clone question template
                updatedTemplate.searchTags = updatedTemplate.searchTags.filter(item => item.id !== tag.id);
                saveQuestionTemplate(updatedTemplate);
            }
        }

        saveTagAndCloseDrawer(tag, filter);
    };

    return (
        <div style={{height: "100%"}}>
            <ArgoAppBarHook
                title={createMode ? "Create Tag" : "Edit Tag"}
                showMenuIconButton={false}
                noIcon={true}
                isDrawer={true}
                width={tagCreateEditDrawerProps.width}
            />

            <div style={{height: '64px'}}></div>

            <TagEditorHook
                id={createMode ? null : id}
                createMode={createMode}
                save={createMode ? createTagAndClose : saveTagAndClose}
                cancel={handleCloseDrawer}
                width={tagCreateEditDrawerProps.width}
            />
        </div>
    );
}

TagCreateEditDrawerHook.defaultProps = {
    createMode: false,
    id: null,
    filter: {},
};

TagCreateEditDrawerHook.propTypes = {
    createMode: PropTypes.bool,
    id: PropTypes.number,
    filter: PropTypes.object,
    setLoadingState: PropTypes.func,
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({closeDrawer, createTagAndCloseDrawer, saveTagAndCloseDrawer, saveQuestionTemplate}, dispatch);
}

function mapStateToProps(state) {
    return {
        questionTemplates: state.questionTemplate,
        filter: state.filter["tags"] || {}
    };
}

const tagCreateEditDrawerProps = {
    opensecondary: true,
    width: "90%",
    docked: false,
    anchor: "right"
};

export default connect(mapStateToProps, mapDispatchToProps)(TagCreateEditDrawerHook);
export {tagCreateEditDrawerProps};